import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockCarouselComponent } from '@app/components/blocks/block-carousel/block-carousel.component';
import { CarouselModule } from '@app/components/carousel/carousel.module';

@NgModule({
  imports: [CommonModule, CarouselModule],
  declarations: [BlockCarouselComponent],
  exports: [BlockCarouselComponent],
})
export class BlockCarouselModule {}
